import Grid from "@mui/material/Grid";
import {Checkbox, FormControl, FormControlLabel, FormHelperText, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {Add} from "@mui/icons-material";
import * as React from "react";

export default function MerchantForm ({fields, errors, handleChange, handleBlur, handleSubmit, referralsData, currenciesData = []}) {
    return <React.Fragment>
        <Grid container spacing={2}
              component="form"
              onSubmit={handleSubmit}
              autoComplete="off"
        >
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Email</InputLabel>
                <TextField
                    error={!!errors.username}
                    value={fields.username || ""}
                    name="username"
                    id="username"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.username && <FormHelperText>{errors.username}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Password</InputLabel>
                <TextField
                    error={!!errors.password}
                    value={fields.password || ""}
                    type="password"
                    autoComplete="new-password"
                    name="password"
                    id="password"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={fields.id ? 'Keep old password' : 'A-Z a-z 0-9 and !@#$%^&*() =+_-'}
                />
                {errors.password && <FormHelperText>{errors.password}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Name</InputLabel>
                <TextField
                    error={!!errors.name}
                    value={fields.name || ""}
                    name="name"
                    id="name"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.name && <FormHelperText>{errors.name}</FormHelperText>}
            </Grid>
            {Array.isArray(referralsData) && referralsData.length > 0 && (
                <Grid size={{ xs: 12, md: 4 }}>
                    <InputLabel>Referral</InputLabel>
                    <FormControl fullWidth>
                        <Select
                            value={fields.referral_id || ""}
                            name="referral_id"
                            id="referral_id"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            displayEmpty
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {referralsData.map((ref) => (
                                <MenuItem key={`ref-${ref.id}`} value={ref.id}>
                                    {ref.name} ({ref.username})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {errors.referral_id && <FormHelperText>{errors.referral_id}</FormHelperText>}
                </Grid>
            )}
            {Array.isArray(referralsData) && referralsData.length > 0 && (
                <Grid size={{ xs: 12, md: 4 }}>
                    <InputLabel>Referral %</InputLabel>
                    <TextField
                        error={!!errors.referral_percentage}
                        value={fields.referral_percentage ?? ""}
                        name="referral_percentage"
                        id="referral_percentage"
                        fullWidth={true}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="0 - 100"
                    />
                    {errors.referral_percentage && <FormHelperText>{errors.referral_percentage}</FormHelperText>}
                </Grid>
            )}
            <Grid size={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="enabled"
                            checked={typeof fields.enabled === 'boolean' ? fields.enabled : true}
                            onChange={handleChange}
                            value={typeof fields.enabled === 'boolean' ? fields.enabled : true}
                            color="primary"
                        />
                    }
                    label="Enabled"
                />
            </Grid>
            <Grid size={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="can_create_payments"
                            checked={typeof fields.can_create_payments === 'boolean' ? fields.can_create_payments : true}
                            onChange={handleChange}
                            value={typeof fields.can_create_payments === 'boolean' ? fields.can_create_payments : true}
                            color="primary"
                        />
                    }
                    label="Доступ к созданию платежей"
                />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Max daily volume (default currency)</InputLabel>
                <TextField
                    error={!!errors.max_daily_volume}
                    value={fields.max_daily_volume ?? ""}
                    name="max_daily_volume"
                    type="number"
                    id="max_daily_volume"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Empty = no limit"
                    inputProps={{ min: 0, step: 0.01 }}
                />
                <FormHelperText>Max total completed amount per day for this merchant. Leave empty for no limit.</FormHelperText>
                {errors.max_daily_volume && <FormHelperText error>{errors.max_daily_volume}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 12, md: 8 }}>
                <InputLabel>Additional currencies</InputLabel>
                <Select
                    multiple
                    fullWidth
                    name="currency_ids"
                    id="currency_ids"
                    value={Array.isArray(fields.currency_ids) ? fields.currency_ids : []}
                    onChange={handleChange}
                    renderValue={(selected) => {
                        if (!selected || selected.length === 0) return 'Only base: EUR, USD';
                        const map = new Map((currenciesData || []).map((c) => [c.id, c.currency]));
                        return selected.map((id) => map.get(id) || id).join(', ');
                    }}
                >
                    {currenciesData.map((currency) => (
                        <MenuItem key={`currency-${currency.id}`} value={currency.id}>
                            {currency.currency}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>EUR and USD are always allowed. Select extra currencies for this merchant.</FormHelperText>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Checkout mode</InputLabel>
                <FormControl fullWidth error={!!errors.checkout_mode}>
                    <Select
                        name="checkout_mode"
                        id="checkout_mode"
                        value={fields.checkout_mode || 'redirect_checkout'}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <MenuItem value="redirect_checkout">Redirect checkout (legacy)</MenuItem>
                        <MenuItem value="onsite_s2s">Onsite S2S (hosted page on our domain)</MenuItem>
                    </Select>
                    {errors.checkout_mode && <FormHelperText>{errors.checkout_mode}</FormHelperText>}
                </FormControl>
            </Grid>
            <Grid container size={12} spacing={3} sx={{mt: 2}}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Button type="submit" onClick={handleSubmit} variant="outlined" startIcon={<Add />} >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    </React.Fragment>
}
